import './index.css';

import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { loadRuntimeSsoConfig, SsoConfig } from 'softcat:config/sso.ts';
import { LocaleProvider } from 'softcat:contexts/locale.tsx';
import { TerritoryProvider } from 'softcat:contexts/territory.tsx';
import { Routes } from 'softcat:routes/routes.tsx';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const start = async () => {
    await loadRuntimeSsoConfig();

    const oidcConfig = {
        authority: SsoConfig.COGNITO_AUTHORITY,
        automaticSilentRenew: true,
        client_id: SsoConfig.COGNITO_CLIENT_ID,
        onSigninCallback: () => {
            globalThis.history.replaceState({}, document.title, globalThis.location.pathname);
        },
        redirect_uri: SsoConfig.REDIRECT_URI,
        response_type: 'code',
        scope: 'email openid softcat/read softcat/write',
    };

    ReactDOM.createRoot(document.querySelector('#root')!).render(
        <React.StrictMode>
            <AuthProvider {...oidcConfig}>
                <LocaleProvider>
                    <TerritoryProvider>
                        <RouterProvider
                            router={sentryCreateBrowserRouter(Routes(import.meta.env.MODE), {
                                basename: import.meta.env.BASE_URL,
                            })}
                        />
                    </TerritoryProvider>
                </LocaleProvider>
            </AuthProvider>
        </React.StrictMode>,
    );
};

start();
